'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _recompose = require('recompose');

var LOADING_STATES = {
    INITIAL: 'INITIAL',
    LOADING: 'LOADING',
    SUCCESS: 'SUCCESS'
};

var enhance = (0, _recompose.compose)((0, _recompose.withState)('loadingState', 'updateLoadingState', ''), (0, _recompose.withState)('loadingTransitionError', 'updateTransitionError', ''), (0, _recompose.withHandlers)({
    setLoading: function setLoading(props) {
        return function (event) {
            return props.updateLoadingState(LOADING_STATES.LOADING);
        };
    },
    setSuccess: function setSuccess(props) {
        return function (event) {
            return props.updateLoadingState(LOADING_STATES.SUCCESS);
        };
    },
    setInitial: function setInitial(props) {
        return function (event) {
            return props.updateLoadingState(LOADING_STATES.INITIAL);
        };
    },
    setLoadingError: function setLoadingError(props) {
        return function (event) {
            return props.updateTransitionError(event);
        };
    },
    clearLoadingError: function clearLoadingError(props) {
        return function (event) {
            return props.updateTransitionError(null);
        };
    }
}), (0, _recompose.withProps)(function (props) {
    return {
        isLoading: props.loadingState === LOADING_STATES.LOADING,
        isSuccessful: props.loadingState === LOADING_STATES.SUCCESS
    };
}));

exports.default = enhance;


//////////////////
// WEBPACK FOOTER
// ./src/client/components/loaders/loadingTransitionDecorator.js
// module id = 709
// module chunks = 0